module.exports = __webpack_public_path__ + "static/media/img74_R.a5dade57.jpg";